import { render, staticRenderFns } from "./UserPackageUpdate.vue?vue&type=template&id=3b931f19&scoped=true"
import script from "./UserPackageUpdate.vue?vue&type=script&lang=js"
export * from "./UserPackageUpdate.vue?vue&type=script&lang=js"
import style0 from "./UserPackageUpdate.vue?vue&type=style&index=0&id=3b931f19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b931f19",
  null
  
)

export default component.exports